import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import { formatClutchDate } from 'src/utils/formatDate';

const cardSx = {
  bgcolor: '#151921',
  border: '1px solid #232935',
  borderRadius: 1.5
};

function formatCompletedAt(value) {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function AnswerRow({ answer }) {
  const title = answer.questionTitle || answer.questionKey || 'Question';
  const prompt = answer.questionText;
  const value = answer.displayValue ?? answer.optionKey ?? answer.numericValue ?? '—';

  return (
    <Box sx={{ py: 0.65 }}>
      <Typography sx={{ color: '#F3F4F6', fontSize: '0.78rem', fontWeight: 600, lineHeight: 1.3 }}>
        {title}
      </Typography>
      {prompt && (
        <Typography sx={{ color: '#6B7280', fontSize: '0.65rem', lineHeight: 1.35, mt: 0.2 }}>
          {prompt}
        </Typography>
      )}
      <Typography sx={{ color: '#3F90DF', fontSize: '0.75rem', fontWeight: 600, mt: 0.35 }}>
        {value}
      </Typography>
    </Box>
  );
}

export default function SurveyResponseCard({ response, headingPrefix = 'Morning wellness' }) {
  const answers = response?.answers || [];
  const submittedLabel = formatCompletedAt(response?.completedAt);
  const responseDay = response?.responseDate || response?.completedAt?.slice(0, 10);

  return (
    <Card sx={cardSx} elevation={0}>
      <Box sx={{ p: 1.25 }}>
        <Typography
          sx={{
            color: '#3F90DF',
            fontSize: '0.62rem',
            fontWeight: 700,
            letterSpacing: '0.06em'
          }}
        >
          {headingPrefix.toUpperCase()} · {formatClutchDate(responseDay).toUpperCase()}
        </Typography>
        {submittedLabel && (
          <Typography sx={{ color: '#6B7280', fontSize: '0.62rem', mt: 0.35 }}>
            Submitted {submittedLabel}
          </Typography>
        )}
        <Divider sx={{ borderColor: '#232935', my: 0.85 }} />
        <Stack divider={<Divider flexItem sx={{ borderColor: '#232935' }} />} spacing={0}>
          {answers.length === 0 && (
            <Typography sx={{ color: '#9CA3AF', fontSize: '0.75rem' }}>No answers recorded.</Typography>
          )}
          {answers.map((answer) => (
            <AnswerRow key={`${response?.id}-${answer.questionKey}`} answer={answer} />
          ))}
        </Stack>
      </Box>
    </Card>
  );
}
